import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-filter-button',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './filter-button.component.html',
  styleUrl: './filter-button.component.css',
})
export class FilterButtonComponent {
  hasActiveFilters = input(false);
  size = input<'sm' | 'md' | 'lg'>('sm');

  buttonClick = output<MouseEvent>();

  onClick(event: MouseEvent): void {
    this.buttonClick.emit(event);
  }
}
